<template>
  <div>
    <form @submit.prevent="handleSubmit" action="" class="container p-4">
      <div class="row">
        <h4>{{ isEditing ? "Edit" : "Add" }} Report</h4>
      </div>
      <div class="row">
        <div class="col">
          <TextInput v-model="report.name" :validator="$v.value.name" label="Name" maxLength="51" />
          <text-area-input
            v-model="report.description"
            label="Description"
            :resize="false"
            maxLength="2001"
            rows="5"
            :validator="$v.value.description"
            :disabled="!permissions.ReportCreateEdit && !permissions.ReportDescriptionEdit"
          />
        </div>
        <div class="col">
          <date-picker
            v-model="report.lastRunOn"
            name="lastRunOn"
            :disabled="true"
            label="Last Run On"
          />
          <text-input v-model="report.lastRunBy" name="lastRunBy" disabled label="Last Run By" />
          <select-input
            label="Group"
            :dataSource="groups"
            v-model="report.reportGroupId"
            :disabled="!permissions.ReportCreateEdit && !permissions.ReportGroupEdit"
          />
        </div>
      </div>
      <div class="row justify-content-between mx-1">
        <button type="button" :class="scheduleButtonClass" @click="toggleSchedulePopup">
          Schedule
        </button>
        <div class="row justify-content-end">
          <button type="submit" :disabled="$v.value.$invalid" class="btn btn-primary">
            Submit
          </button>
          <button type="button" @click="handleCancel" class="mx-2 btn btn-danger">Cancel</button>
        </div>
      </div>
    </form>
    <Modal :status="isSchedulePopupOpen" @close="toggleSchedulePopup">
      <ReportSchedule @cancel="toggleSchedulePopup" :selectedReport="value" />
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DatePicker from "../common/DatePicker.vue";
import TextAreaInput from "../TextAreaInput.vue";
import ReportService from "../../services/Reports";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import SelectInput from "@/components/common/SelectInput.vue";
import TextInput from "@/components/common/TextInput.vue";
import { handleErrors } from "@/modules/handleErrors";
import Modal from "../common/Modal.vue";
import ReportSchedule from "../ReportSchedule.vue";
const alphaNum = helpers.regex("alphaNum", /[0-9A-Z-]/i);
export default {
  components: { DatePicker, TextAreaInput, SelectInput, TextInput, Modal, ReportSchedule },
  props: ["value"],
  name: "ReportsForm",
  created() {
    this.$store.dispatch("dropdowns/getReportGroups");
  },
  data() {
    return {
      // IP-2013 - replace with value from back end
      schedules: [],
      isSchedulePopupOpen: false
    };
  },
  validations: {
    value: {
      name: {
        required,
        maxLength: maxLength(50),
        alphaNum
      },
      description: {
        maxLength: maxLength(2000),
        alphaNum
      }
    }
  },
  computed: {
    ...mapState(["currentUser", "currentLab"]),
    ...mapState({
      groups: state => state.dropdowns.reportGroups
    }),
    ...mapGetters(["permissions"]),
    report: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      }
    },
    isEditing() {
      if (this.value.id) {
        return true;
      }
      return false;
    },
    scheduleButtonClass() {
      let buttonClass = "info";
      if (this.schedules?.length) {
        buttonClass = "success";
      }
      return "btn btn-" + buttonClass;
    }
  },
  methods: {
    handleSubmit() {
      if (this.$v.$invalid) {
        return;
      }
      ReportService.updateReport(this.value)
        .then(res => {
          if (res) {
            window.notify("Updated report " + this.value.name, "success");
            this.$emit("close");
          }
        })
        .catch(error => {
          handleErrors(error);
        });
    },
    async handleCancel() {
      const confirm = await window.confirm("Are you sure you want to discard any data entered?");
      if (confirm) {
        this.$emit("close");
      }
    },
    toggleSchedulePopup() {
      this.isSchedulePopupOpen = !this.isSchedulePopupOpen;
    }
  }
};
</script>

<style lang="scss" scoped></style>
